import React, { useState } from "react";
const Directorate = ({ data }) => {
  const [selectedOption, setSelectedOption] = useState("overview");
  return (
    <div className="flex flex-col lg:gap-6 md:gap-4 gap-2 xl:py-20 lg:py-14 sm:py-10 py-6 bg-white md:bg-[#F6F6F6] xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%] ">
      <h1 className="text-[#00643b] font-semibold md:text-[1.3rem] text-[1rem]">
        Directorates
      </h1>
      <div className="flex flex-col lg:gap-10 gap-5">
        <div className=" w-full flex flex-col gap-6">
          <h1 className="   lg:text-[3rem] text-[2rem] font-bold ">
            {data?.name}
          </h1>
          <div className="flex items-center justify-start w-max lg:gap-6 md:gap-4 gap-2   border-b border-[#0000002E]">
            {["overview", "function & Responsibilities", "commitment"].map(
              (option) => (
                <label
                  key={option}
                  className={`flex items-center cursor-pointer transition-all duration-500 lg:text-[1.2rem] md:text-[1.1rem] sm:text-[1rem] text-[.7rem]   ${
                    selectedOption === option
                      ? "text-[#00643b] border-b-2 border-[#00643b] font-semibold"
                      : " text-black"
                  } py-1 lg:px-5 md:px-4 sm:px-2.5 px-1 `}
                >
                  <input
                    type="radio"
                    value={option}
                    checked={selectedOption === option}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    className="hidden"
                  />
                  <span className="capitalize">
                    {option.replace(/([A-Z])/g, " $1")}
                  </span>
                </label>
              )
            )}
          </div>
          {selectedOption === "overview" && (
            <div className=" 2xl:text-[1.5rem] md:text-[1.3rem] text-[1rem]">
              {data?.overview}
            </div>
          )}
          {selectedOption === "function & Responsibilities" && (
            <div className="2xl:text-[1.5rem] md:text-[1.3rem] text-[1rem]">
              <ul className=" list-disc list-inside">
                {data?.functionsResponsibilities?.map((list, i) => (
                  <li key={i}>{list}</li>
                ))}
              </ul>
            </div>
          )}
          {selectedOption === "commitment" && (
            <div className="2xl:text-[1.5rem] md:text-[1.3rem] text-[1rem]">
              {data?.commitment}
            </div>
          )}
        </div>
        <img
          src={data?.image}
          alt="banner"
          className=" w-full rounded-2xl sm:aspect-auto aspect-[1/.6] object-cover"
        />
      </div>
    </div>
  );
};
export default Directorate;
